<template>
  <div>
    <router-view></router-view>
    <portal-target name="modals" multiple></portal-target>
  </div>
</template>

<style lang="scss">
// 3rd party plugins css
@import "~bootstrap-vue/dist/bootstrap-vue.css";
@import "~perfect-scrollbar/css/perfect-scrollbar.css";
@import "~socicon/css/socicon.css";
@import "~@fortawesome/fontawesome-free/css/all.css";
@import "~line-awesome/dist/line-awesome/css/line-awesome.css";
@import "assets/plugins/flaticon/flaticon.css";
@import "assets/plugins/flaticon2/flaticon.css";
@import "assets/plugins/keenthemes-icons/font/ki.css";
@import "assets/sass/style.vue";
@import "assets/sass/switch";
@import "vue-select/src/scss/vue-select.scss";
$white: #ffffff;

select {
  -webkit-appearance: none;
  -moz-appearance: none;
  background: transparent;
  background-image: url("data:image/svg+xml;utf8,<svg fill='black' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>");
  background-repeat: no-repeat;
  background-position-x: 100%;
  background-position-y: 15px;
  border: 1px solid #dfdfdf;
  border-radius: 2px;
  margin-right: 2rem;
  padding: 1rem;
  padding-right: 2rem;
}
.new-service {
  .cleft {
    float: left;
  }

  .form-control {
    height: calc(1.5em + 1.3rem + 15px);
    background-color: $white;
    border: none;
  }
}
.mx-datepicker {
  width: 100% !important;
  .mx-input {
    height: 40px;
    border: none;
  }
}
input {
  height: 40px;
}

.full-load {
  -ms-overflow-style: none; /* for Internet Explorer, Edge */
  scrollbar-width: none; /* for Firefox */
  overflow-y: scroll;
  left: 0;
  color: white;
  width: 100%;
  height: 100%;
  background: #0000007d;
  position: fixed;
  z-index: 9999;
  top: 0;
  bottom: 0;
  text-align: center;
  h1 {
    position: absolute;
    top: 41%;
    bottom: 0;
    margin: auto;
    left: 0;
    right: 0;
  }
}

.mx-input-wrapper {
  border: 1px solid #e4e6ef;
}

.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}
.swal2-container {
  background-color: #000000b3 !important;
}
.form-validate-required {
  border-right: 2px solid #dc3545 !important;
}
.card-footer {
  background-color: #fff !important;
}

/* ── Toast Redesign ── */
.toast-container {
  font-family: 'Segoe UI', sans-serif !important;
  padding: 16px !important;

  > div {
    border-radius: 12px !important;
    box-shadow: 0 8px 32px rgba(13, 27, 62, 0.14) !important;
    padding: 14px 40px 14px 20px !important;
    width: 320px !important;
    background-image: none !important;
    margin: 0 0 10px !important;
    opacity: 1 !important;
    border-left: 4px solid transparent !important;
  }

  > div:hover {
    box-shadow: 0 12px 40px rgba(13, 27, 62, 0.22) !important;
    opacity: 1 !important;
  }

  > .toast-success {
    background-color: #f0faf4 !important;
    background-image: none !important;
    color: #276749 !important;
    border-left-color: #276749 !important;
  }

  > .toast-error {
    background-color: #fff5f5 !important;
    background-image: none !important;
    color: #c62828 !important;
    border-left-color: #c62828 !important;
  }

  > .toast-warning {
    background-color: #fffaf0 !important;
    background-image: none !important;
    color: #92400e !important;
    border-left-color: #F58020 !important;
  }

  > .toast-info {
    background-color: #eef7fb !important;
    background-image: none !important;
    color: #1a6fa0 !important;
    border-left-color: #389ad4 !important;
  }
}

.toast-title {
  font-size: 13px !important;
  font-weight: 700 !important;
  line-height: 1.4 !important;
  margin-bottom: 2px !important;
}

.toast-message {
  font-size: 13px !important;
  font-weight: 500 !important;
  line-height: 1.5 !important;
  color: inherit !important;
  a, label { color: inherit !important; }
}

.toast-close-button {
  font-size: 16px !important;
  color: inherit !important;
  text-shadow: none !important;
  opacity: 0.5 !important;
  top: -0.1em !important;
  right: -0.1em !important;
  &:hover { opacity: 1 !important; color: inherit !important; }
}

.toast-progress {
  height: 3px !important;
  opacity: 0.25 !important;
  background-color: currentColor !important;
  border-radius: 0 0 0 8px !important;
}

/* ── SweetAlert2 Redesign ── */
.swal2-popup {
  border-radius: 16px !important;
  padding: 30px 26px 26px !important;
  font-family: 'Segoe UI', sans-serif !important;
  box-shadow: 0 20px 60px rgba(13, 27, 62, 0.25) !important;
}

.swal2-title {
  font-size: 19px !important;
  font-weight: 700 !important;
  color: #0d1b3e !important;
  padding: 0 0 4px !important;
}

.swal2-html-container {
  font-size: 14px !important;
  color: #6c7280 !important;
  line-height: 1.5 !important;

  strong { color: #0d1b3e; }
}

.swal2-actions {
  margin-top: 22px !important;
  gap: 10px !important;
}

.swal2-styled {
  border-radius: 10px !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  font-family: 'Segoe UI', sans-serif !important;
  padding: 10px 26px !important;
  box-shadow: none !important;
  transition: opacity 0.15s !important;

  &:focus { box-shadow: none !important; }
  &:hover { opacity: 0.9 !important; }
}

.swal2-styled.swal2-confirm {
  background-color: #389ad4 !important;
}

.swal2-styled.swal2-cancel {
  background-color: #fff !important;
  color: #4a5568 !important;
  border: 1.5px solid #dde2ec !important;

  &:hover { background-color: #f4f6fb !important; opacity: 1 !important; }
}

.swal2-styled.swal2-deny {
  background-color: #b42318 !important;
}

.swal2-close {
  color: #a0aab8 !important;
  transition: color 0.15s !important;

  &:hover { color: #6c7280 !important; background: transparent !important; }
  &:focus { box-shadow: none !important; }
}

/* Icon accents */
.swal2-icon.swal2-warning {
  border-color: #f5a623 !important;
  color: #f5a623 !important;
}

.swal2-icon.swal2-error {
  border-color: #c62828 !important;
  color: #c62828 !important;
}

.swal2-icon.swal2-info {
  border-color: #389ad4 !important;
  color: #389ad4 !important;
}

.swal2-icon.swal2-question {
  border-color: #6b21a8 !important;
  color: #6b21a8 !important;
}

.swal2-icon.swal2-success {
  border-color: #276749 !important;

  .swal2-success-ring { border-color: rgba(39, 103, 73, 0.3) !important; }
  [class^='swal2-success-line'] { background-color: #276749 !important; }
}
</style>

<script src="https://code.jquery.com/jquery-1.12.3.min.js"></script>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/mutations.type";
import { mapGetters } from "vuex";

export default {
  created() {
    this.$store.commit(SET_BREADCRUMB, []);
  },
  computed: {
    ...mapGetters(["isAuthenticated"])
  },
  watch: {
    $route(to) {
      var element = document.getElementById("body");
      if (to.name == "login") {
        element.classList.add("login-page-11231");
      } else {
        element.classList.remove("login-page-11231");
      }
    }
  }
};
</script>
